<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <section class="sales-page">
      <header class="page-header">
        <div class="header-copy">
          <div class="header-icon" aria-hidden="true">
            <!-- <ng-icon name="iconoirCart" size="24"></ng-icon> -->
          </div>
          <div>
            <!-- <h4>{{ dictionary.get('Sales') }}</h4> -->
            <!-- <p>{{ dictionary.get('SalesSheetsDescription') }}</p> -->
          </div>
        </div>

        <div class="header-actions">
          <button
            buttonTheme="light"
            buttonType="regular"
            type="button"
            (click)="refreshTable()"
          >
            <ng-icon name="iconoirRefresh" size="18"></ng-icon>
            {{ dictionary.get('Refresh') }}
          </button>
          <button
            buttonTheme="primary"
            buttonType="regular"
            type="button"
            (click)="openUploadModal()"
          >
            <ng-icon name="iconoirCloudUpload" size="18"></ng-icon>
            {{ dictionary.get('UploadSalesSheet') }}
          </button>
        </div>
      </header>

      <div class="sales-table">
        <ng-template #statusProgress let-status>
          <app-sales-sheet-status-progress [status]="$any(status)" />
        </ng-template>

        <ng-template
          #invalidRowsAction
          let-onClick="onClick"
        >
          <button
            class="invalid-rows-action"
            buttonTheme="light"
            buttonType="regular"
            type="button"
            [attr.aria-label]="dictionary.get('ViewInvalidRows')"
            [title]="dictionary.get('ViewInvalidRows')"
            (click)="handleInvalidRowsAction($event, onClick)"
          >
            {{ dictionary.get('View') }}
          </button>
        </ng-template>

        <app-api-table
          #salesTable
          endpoint="/sales-sheet/tables/company"
          [name]="dictionary.get('SalesSheets')"
          [hasChartView]="false"
          [skipDateRange]="true"
          [defaultSort]="{ 'Uploaded At': 'desc' }"
          [customCells]="[
            {
              column: 'Status',
              template: statusProgress,
              minWidth: 320,
              rowHeight: 88,
            },
          ]"
          [actionCol]="[
            {
              actionButton: invalidRowsAction,
              headerName: dictionary.get('InvalidRows'),
              onClick: openInvalidRows,
            },
          ]"
          [onRowClick]="openSheet"
        ></app-api-table>
      </div>
    </section>

    @if (uploadModalOpen()) {
      <app-modal
        [(opened)]="uploadModalOpen"
        size="md"
        [title]="dictionary.get('UploadSalesSheet')"
        (closeTrigger)="closeUploadModal()"
      >
        <div class="upload-form">
          <p class="form-intro">{{ dictionary.get('UploadSalesSheetDescription') }}</p>

          <div class="field">
            <label>{{ dictionary.get('Distributor') }} *</label>
            @if (distributorsLoading()) {
              <app-loading-spinner
                size="sm"
                [label]="dictionary.get('LoadingDistributors')"
              />
            } @else if (distributorsError()) {
              <div class="field-state error-state">
                <span>{{ dictionary.get('DistributorsLoadFailed') }}</span>
                <button
                  buttonTheme="light"
                  buttonType="regular"
                  type="button"
                  (click)="loadDistributors()"
                >
                  {{ dictionary.get('Retry') }}
                </button>
              </div>
            } @else if (!distributors().length) {
              <div class="field-state">{{ dictionary.get('NoDistributorsFound') }}</div>
            } @else {
              <app-select
                [options]="distributorNames()"
                [optionsIds]="distributorIds()"
                [isFullWidth]="true"
                [placeholder]="dictionary.get('SelectDistributor')"
                (getSelectedOption)="selectDistributor($event)"
              ></app-select>
              @if (submitAttempted() && !selectedDistributorId()) {
                <small class="validation-error">{{ dictionary.get('DistributorRequired') }}</small>
              }
            }
          </div>

          <div class="field">
            <label>{{ dictionary.get('SalesSheetType') }} *</label>
            <app-select
              [options]="sheetTypeOptions"
              [optionsIds]="sheetTypeOptions"
              [isFullWidth]="true"
              [disableSearch]="true"
              [placeholder]="dictionary.get('SelectSalesSheetType')"
              (getSelectedOption)="selectSheetType($event)"
            ></app-select>
            @if (submitAttempted() && !selectedSheetType()) {
              <small class="validation-error">{{ dictionary.get('SalesSheetTypeRequired') }}</small>
            }
          </div>

          <div class="field">
            <label>{{ dictionary.get('SalesSheetFile') }} *</label>
            <input
              #fileInput
              class="visually-hidden"
              type="file"
              accept=".xlsx,.xls,.csv"
              (change)="selectFile($event)"
            />

            @if (selectedFile(); as file) {
              <div class="selected-file">
                <div>
                  <strong>{{ file.name }}</strong>
                  <span>{{ formatFileSize(file) }}</span>
                </div>
                <button type="button" (click)="removeFile()">
                  {{ dictionary.get('Remove') }}
                </button>
              </div>
            } @else {
              <button
                class="file-picker"
                type="button"
                (click)="fileInput.click()"
              >
                <ng-icon name="iconoirCloudUpload" size="24"></ng-icon>
                <strong>{{ dictionary.get('ChooseSalesSheetFile') }}</strong>
                <span>{{ dictionary.get('SalesSheetFileHint') }}</span>
              </button>
            }

            @if (fileError()) {
              <small class="validation-error">{{ fileError() }}</small>
            } @else if (submitAttempted() && !selectedFile()) {
              <small class="validation-error">{{ dictionary.get('SalesSheetFileRequired') }}</small>
            }
          </div>

          <div class="modal-actions">
            <button
              buttonTheme="light"
              buttonType="regular"
              type="button"
              [disabled]="uploading()"
              (click)="closeUploadModal()"
            >
              {{ dictionary.get('Cancel') }}
            </button>
            <button
              buttonTheme="primary"
              buttonType="regular"
              type="button"
              [disabled]="!canSubmit()"
              [loading]="uploading()"
              (click)="submitUpload()"
            >
              {{ uploading() ? dictionary.get('Uploading') : dictionary.get('Upload') }}
            </button>
          </div>
        </div>
      </app-modal>
    }

    @if (invalidRowsModalOpen()) {
      <app-modal
        [(opened)]="invalidRowsModalOpen"
        size="xl"
        [title]="invalidRowsModalTitle()"
        [loading]="invalidRowsLoading()"
        (closeTrigger)="closeInvalidRowsModal()"
      >
        @if (invalidRowsError(); as errorMessage) {
          <div class="field-state error-state invalid-rows-error">
            <span>{{ errorMessage }}</span>
            <button
              buttonTheme="light"
              buttonType="regular"
              type="button"
              (click)="retryInvalidRows()"
            >
              {{ dictionary.get('Retry') }}
            </button>
          </div>
        } @else {
          @if (invalidRowsData(); as tableData) {
            <div class="invalid-rows-table">
              <app-static-table
                name="sales-sheet-invalid-rows"
                [data]="tableData"
                [static]="true"
                [controls]="false"
                [canExport]="false"
                [hasChartView]="false"
              />
            </div>
          }
        }
      </app-modal>
    }
  }
</app-tab-layout>
